import { GetServerSidePropsContext } from 'next';
import SingleFundSustainabilityPage, {
  getServerSidePropsSusPage,
  SusPageProps,
} from '../../../domains/sustainability/SusPageTemplate';
import withAppProps from '../../../utils/withAppProps';
import { UrlError } from '../../../utils/error';
import { resolvedUrlToSlug } from '../../../utils/helpers/resolvedUrlToSlug';

export const getServerSideProps = withAppProps<SusPageProps>(
  async (context: GetServerSidePropsContext) => {
    const donationProgramSlug = resolvedUrlToSlug(context.resolvedUrl);
    const props = await getServerSidePropsSusPage({ slug: donationProgramSlug });
    if (props) {
      return props;
    }

    throw new UrlError(`No page found for slug`, { status: 404 });
  },
);

export default function Page(props: SusPageProps) {
  return <SingleFundSustainabilityPage serverSideProps={props} />;
}
